import { WagmiProvider } from 'wagmi';
import { wagmiConfig } from '@/lib/web3-config';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { ReactNode, useMemo } from 'react';
import { clusterApiUrl } from '@solana/web3.js';

const SOLANA_RPC = clusterApiUrl('mainnet-beta');
const TON_MANIFEST_URL = `${window.location.origin}/tonconnect-manifest.json`;

export const Web3Provider = ({ children }: { children: ReactNode }) => {
  const solanaWallets = useMemo(() => [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
  ], []);

  return (
    <WagmiProvider config={wagmiConfig}>
      <ConnectionProvider endpoint={SOLANA_RPC}>
        <WalletProvider wallets={solanaWallets} autoConnect>
          <TonConnectUIProvider manifestUrl={TON_MANIFEST_URL}>
            {children}
          </TonConnectUIProvider>
        </WalletProvider>
      </ConnectionProvider>
    </WagmiProvider>
  );
};
